import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbySeo } from "gatsby-plugin-next-seo"

const query = graphql`
  {
    site {
      siteMetadata {
        siteDesc: description
        siteTitle: title
        siteUrl
        author
        keywords
      }
    }
  }
`
const Seo = ({
  title,
  description,
  pathname,
  noindex = false,
  nofollow = false,
}) => {
  const { site } = useStaticQuery(query)

  const { siteUrl, siteDesc, siteTitle, author, keywords } = site.siteMetadata

  const canonical = pathname
    ? `${siteUrl}${pathname === "/" ? "" : `${pathname}/`}`
    : null

  const canonicalProps = { rel: "canonical", href: canonical }

  if (process.env.GATSBY_APP_DEV === "true") {
    noindex = true
    nofollow = true
  }

  return (
    <GatsbySeo
      title={title}
      titleTemplate={`%s | ${siteTitle}`}
      description={description || siteDesc}
      // language={intl.locale}
      canonical={canonicalProps.href}
      noindex={noindex}
      nofollow={nofollow}
      metaTags={[
        {
          property: "author",
          content: author,
        },
        {
          property: "keywords",
          content: keywords,
        },
        {
          "http-equiv": "Content-Security-Policy",
          content: "upgrade-insecure-requests",
        },
      ]}
      openGraph={{
        url: canonicalProps.href,
        title: `${title} | ${siteTitle}`,
        site_name: `${siteTitle}`,
        description: description || siteDesc,
        images: [
          {
            url: `${siteUrl}/images/og-image.png`,
            width: 1200,
            height: 630,
            alt: `${siteTitle}`,
          },
        ],
      }}
    />
  )
}

Seo.defaultProps = {
  title: null,
  description: null,
  lang: `en`,
  meta: [],
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default Seo
